import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from './theme';
import { DefaultLayout } from './layout';
import Login from './views/auth/Login';
import Register from './views/auth/Register';
import Page404 from './views/pages/Page404';
import Unauthorized from './views/pages/Unauthorized';
import authService from './services/auth.service';
import { logout, manualRefreshUserData } from './store/auth/authSlice';
import { Box, CircularProgress } from '@mui/material';

const App = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const user = authService.getCurrentUser();
    if (user && user.access) {
      authService.getUserDetails()
        .then(userDetails => {
          dispatch(manualRefreshUserData({
            user: { ...user, ...userDetails }
          }));
        })
        .catch(err => {
          console.error("Failed to refresh user data:", err);
          dispatch(logout());
        });
    }
  }, [dispatch]);

  if (loading) {
    return (
      <ThemeProvider>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: (theme) => theme.palette.background.default,
          }}
        >
          <CircularProgress color="primary" size={48} />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={4000}
      >
        <Router>
          <Routes>
            <Route path="/login" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} />
            <Route path="/register" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Register />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/*" element={
              isLoggedIn ? <DefaultLayout /> : <Navigate to="/login" />
            } />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
